import type { Rules } from "async-validator";
import type { ComposerTranslation } from "vue-i18n";

export function getEntityLocationValidationRules(
  t: ComposerTranslation,
): Rules {
  return {
    latitude: [
      {
        type: "number",
        required: false,
        min: -90,
        max: 90,
        message: t("administration.entityLocation.latitudeError"),
      },
    ],
    longitude: [
      {
        type: "number",
        required: false,
        min: -180,
        max: 180,
        message: t("administration.entityLocation.longitudeError"),
      },
    ],
    country: [
      {
        type: "string",
        required: true,
        message: t("administration.entityLocation.countryError"),
      },
    ],
    timezone: [
      {
        type: "string",
        required: true,
        message: t("administration.entityLocation.timezoneError"),
      },
    ],
  };
}
